import React, { useCallback, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import MuiDialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { ModalInfo } from "../../UserContext";
import { useClientPayments } from "../../hooks/useClientPayments";
import { useSnackbar } from "notistack";

const styles = {
  centered: {
    textAlign: "center",
  },
  minHeight: {
    maxHeight: 680,
    padding: 0,
    overflow: "hidden",
  },
  display: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  flexEnd: {
    display: "flex",
    padding: 10,
    justifyContent: "flex-end",
  },
};

const DialogTitle = withStyles(styles)((props) => {
  const { classes, onClose } = props;
  return (
    <MuiDialogTitle className={classes.flexEnd}>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
          size="large"
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const PaymentModal = ({ classes, onComplete, userPreferredLanguage }) => {
  const { enqueueSnackbar } = useSnackbar();
  const {
    modal: { open, clientId, businessLocationId, payments },
    dispatchModal,
  } = useContext(ModalInfo);
  const { isLoading, paymentUrl, transaction, error } = useClientPayments(
    clientId,
    businessLocationId,
    payments,
    userPreferredLanguage
  );

  const close = useCallback(
    (e) => {
      enqueueSnackbar("Payment Cancelled", {
        variant: "info",
      });
      dispatchModal({ type: "toogleModal", payload: false });
    },
    [dispatchModal, enqueueSnackbar]
  );

  useEffect(() => {
    if (!transaction) return;
    if (transaction?.responseCode === "Approved") {
      enqueueSnackbar("Payment Accepted", {
        variant: "success",
      });
      if (onComplete) {
        onComplete(transaction);
      }
      dispatchModal({ type: "toogleModal", payload: false });
      return;
    }
    enqueueSnackbar(transaction?.responseDescription || "Payment Cancelled", {
      variant: "error",
    });
    dispatchModal({ type: "toogleModal", payload: false });
  }, [transaction, enqueueSnackbar, onComplete, dispatchModal]);

  return (
    <Dialog
      open={open}
      className={classes.centered}
      fullWidth={true}
      maxWidth={"lg"}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="customized-dialog-title" onClose={close}></DialogTitle>
      <DialogContent className={classes.minHeight}>
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{ height: "70vh" }}
          overflow-y="scroll"
        >
          {isLoading && <CircularProgress />}
          {error && <Typography>{error}</Typography>}
          {!isLoading && !error && (
            <iframe
              title="payment"
              width="95%"
              height="100%"
              marginHeight="0"
              marginWidth="0"
              frameBorder="0"
              src={paymentUrl}
            />
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

PaymentModal.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PaymentModal);
